import { ChevronUp, RotateCcw } from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setToogleHeader } from "../../core/redux/action";
import { OverlayTrigger, Tooltip, Modal, Table } from "react-bootstrap";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Select, message } from "antd";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import {
  AllCommunityModule,
  ModuleRegistry,
  provideGlobalGridOptions,
} from "ag-grid-community";
import { fetchBrandsBySelectedClients, getCurrentUser } from "../../core/api/settings";
import { fetchWordPressOrders, syncWordPressOrders } from "../../core/api/data";
import LineItemsModal from "./components/LineItemsModal";
import ShippingLinesModal from "./components/ShippingLinesModal";
import RealStripeTransactionsModal from "./components/RealStripeTransactionsModal";
import RealAuthTransactionsModalForWeb from "./components/RealAuthTransactionsModalForWeb";
import formatDateWithTimezone from "../../utils/dateUtils";
import {dateFilterParams} from "../../utils/dateUtils";

ModuleRegistry.registerModules([AllCommunityModule]);
provideGlobalGridOptions({ theme: "legacy" });

const WordPressOrders = ({timezone, filters, refreshTrigger}) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);

  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [brands, setBrands] = useState([]);
  const selectedClients = useSelector((state) => state.selectedClients);
  const [loadingBrands, setLoadingBrands] = useState(false);
  const [lastSyncTime, setLastSyncTime] = useState(null);
  const [syncInProgress, setSyncInProgress] = useState(false);
  const [user, setUser] = useState(null);
  const [userLoading, setUserLoading] = useState(true);
  
  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showShippingModal, setShowShippingModal] = useState(false);
  const [selectedShippingLines, setSelectedShippingLines] = useState(null);
  const [showStripeTransactionsModal, setShowStripeTransactionsModal] = useState(false);
  const [selectedOrderForStripe, setSelectedOrderForStripe] = useState(null);
  const [showAuthTransactionsModal, setShowAuthTransactionsModal] = useState(false);
  const [selectedOrderForAuth, setSelectedOrderForAuth] = useState(null);

  useEffect(() => {
    if (filters && filters.brands && filters.brands.length > 0) {
      setLoading(true);
      fetchOrdersData(filters.brands[0], filters);
    } else {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    if (refreshTrigger > 0 && filters && filters.brands && filters.brands.length > 0) {
      setLoading(true);
      fetchOrdersData(filters.brands[0], filters);
    }
  }, [refreshTrigger]);

  
  
  const fetchOrdersData = (brandId, currentFilters = null) => {
    setLoading(true);
    
    const fetchPromise = currentFilters
      ? fetchWordPressOrders(brandId, currentFilters)
      : fetchWordPressOrders(brandId);
      
    fetchPromise
      .then((response) => {
        const ordersData = response.results || response;
        
        if (response.last_sync_time) {
          const syncDate = new Date(response.last_sync_time);
          setLastSyncTime(syncDate.toLocaleString());
        }
        
        if (!ordersData || ordersData.length === 0) {
          message.warning("No WordPress orders found for this brand.");
          setRowData([]);
          setLoading(false);
          return;
        }

        const formattedData = ordersData.map(order => {
          // const formattedDate = order.date_created ? new Date(order.date_created).toLocaleString() : '';
          
          const customerName = order.billing ? 
            `${order.billing.first_name || ''} ${order.billing.last_name || ''}`.trim() : 
            '';
          
          const lineItems = Array.isArray(order.line_items) ? order.line_items : 
                          (typeof order.line_items === 'string' ? JSON.parse(order.line_items) : []);
          
          const shippingLines = Array.isArray(order.shipping_lines) ? order.shipping_lines : 
                          (typeof order.shipping_lines === 'string' ? JSON.parse(order.shipping_lines) : []);
          
          const productsFormatted = lineItems.map(item => 
            `${item.name} (${item.quantity}) - ${order.currency_symbol}${parseFloat(item.total).toFixed(2)}`
          ).join('\n');
          
          const totalQuantity = lineItems.reduce((sum, item) => sum + item.quantity, 0);
          
          const productNames = lineItems.map(item => item.name).join(', ');
          
          return {
            ...order,
            // formattedDate,
            customerName,
            total: parseFloat(order.total).toFixed(2),
            lineItemsFormatted: productsFormatted,
            totalQuantity,
            productNames,
            lineItemsArray: lineItems,
            shippingLinesArray: shippingLines
          };
        });

        setRowData(formattedData);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching WordPress orders:", error);
        message.error("Failed to fetch WordPress orders.");
        setLoading(false);
      });
  };

  const handleSyncWordPress = () => {
    if (!filters || !filters.brands || filters.brands.length === 0) {
      message.warning("Please select a brand first.");
      return;
    }
    
    const brandId = filters.brands[0];
    setSyncInProgress(true);
    message.loading("Syncing WordPress orders...", 0);

    syncWordPressOrders(brandId)
      .then((data) => {
        message.destroy();
        message.success(`Successfully synced WordPress orders. Created: ${data.orders_created || 0}, Updated: ${data.orders_updated || 0}`);
        
        if (data.last_sync_time) {
          const syncDate = new Date(data.last_sync_time);
          setLastSyncTime(syncDate.toLocaleString());
        } else {
          setLastSyncTime(new Date().toLocaleString());
        }
        
        fetchOrdersData(brandId, filters);
      })
      .catch((error) => {
        message.destroy();
        console.error("Error syncing WordPress orders:", error);
        message.error("Failed to sync WordPress orders. " + (error.response?.data?.error || ""));
      })
      .finally(() => {
        setSyncInProgress(false);
      });
  };

  // Define columns for the AG Grid
  const columns = [
    {
      headerName: "#",
      field: "index",
      sortable: true,
      filter: false,
      pinned: "left",
      width: 50,
      valueGetter: (params) => {
        return params.node.rowIndex + 1;
      },
    },
    {
      headerName: "Order ID",
      field: "order_id",
      sortable: true,
      filter: true,
      width: 100,
      resizable: true,
      pinned: "left",
    },
    {
      headerName: "Number",
      field: "number",
      sortable: true,
      filter: true,
      width: 100,
      resizable: true,
    },
    {
      headerName: "Date",
      field: "date_created_gmt",
      sortable: true,
      filter: 'agDateColumnFilter',  filterParams: dateFilterParams,
      width: 220,
      resizable: true,
      valueFormatter: (p) => formatDateWithTimezone(p.value, timezone),
    },
    {
      headerName: "Customer",
      field: "customerName",
      sortable: true,
      filter: true,
      width: 180,
      resizable: true,
    },
    {
      headerName: "Products",
      field: "productNames",
      sortable: true,
      filter: true,
      width: 250,
      resizable: true,
      tooltipField: "lineItemsFormatted",
    },
    {
      headerName: "Line Items",
      field: "lineItemsArray",
      sortable: false,
      filter: false,
      width: 150,
      resizable: true,
      cellRenderer: (params) => {
        if (!params.value || !Array.isArray(params.value) || params.value.length === 0) {
          return '';
        }
        
        const ViewDetailsButton = () => {
          return (
            <button 
            className="btn btn-xs btn-outline-info"
            onClick={() => {
                setSelectedOrder(params.data);
                setShowModal(true);
              }}
            >
              View {params.value.length} {params.value.length === 1 ? 'Item' : 'Items'}
            </button>
          );
        };
        
        return <ViewDetailsButton />;
      },
    },
    {
      headerName: "Status",
      field: "status",
      sortable: true,
      filter: true,
      width: 120,
      resizable: true,
    },
    {
      headerName: "Currency",
      field: "currency",
      sortable: true,
      filter: true,
      width: 90,
      resizable: true,
    },
    {
      headerName: "Discount",
      field: "discount_total",
      sortable: true,
      filter: true,
      width: 100,
      resizable: true,
      valueFormatter: (params) => {
        return params.value ? `${params.data.currency_symbol}${params.value}` : '';
      },
    },
    {
      headerName: "Shipping",
      field: "shipping_total",
      sortable: true,
      filter: true,
      width: 100,
      resizable: true,
      valueFormatter: (params) => {
        return params.value ? `${params.data.currency_symbol}${params.value}` : '';
      },
    },
    {
      headerName: "Shipping Lines",
      field: "shippingLinesArray",
      sortable: false,
      filter: false,
      width: 180,
      resizable: true,
      cellRenderer: (params) => {
        if (!params.value || !Array.isArray(params.value) || params.value.length === 0) {
          return '';
        }
        
        const ViewShippingButton = () => {
          return (
            <button 
            className="btn btn-xs btn-outline-primary"
            onClick={() => {
                setSelectedShippingLines(params.value);
                setShowShippingModal(true);
              }}
            >
              View {params.value.length} {params.value.length === 1 ? 'Method' : 'Methods'}
            </button>
          );
        };
        
        return <ViewShippingButton />;
      },
    },
    {
      headerName: "Shipping Name",
      field: "shipping",
      sortable: false,
      filter: false,
      width: 180,
      resizable: true,
      valueFormatter: (params) => {
        if (!params.value) return '';
        const shipping = params.value;
        return `${shipping.first_name || ''} ${shipping.last_name || ''}`.trim();
      },
    },
    {
      headerName: "Shipping Phone",
      field: "shipping.phone",
      sortable: true,
      filter: true,
      width: 150,
      resizable: true,
    },
    {
      headerName: "Shipping Address",
      field: "shipping",
      sortable: false,
      filter: false,
      width: 250,
      resizable: true,
      valueFormatter: (params) => {
        if (!params.value) return '';
        const shipping = params.value;
        return `${shipping.address_1 || ''} ${shipping.address_2 || ''}, ${shipping.city || ''}, ${shipping.state || ''} ${shipping.postcode || ''}, ${shipping.country || ''}`.trim().replace(/, ,/g, ',').replace(/,,/g, ',');
      },
    },
    {
      headerName: "Shipping City",
      field: "shipping.city",
      sortable: true,
      filter: true,
      width: 120,
      resizable: true,
    },
    {
      headerName: "Shipping State",
      field: "shipping.state",
      sortable: true,
      filter: true,
      width: 100,
      resizable: true,
    },
    {
      headerName: "Shipping Country",
      field: "shipping.country",
      sortable: true,
      filter: true,
      width: 100,
      resizable: true,
    },
    {
      headerName: "Shipping Postcode",
      field: "shipping.postcode",
      sortable: true,
      filter: true,
      width: 120,
      resizable: true,
    },
    {
      headerName: "Tax",
      field: "total_tax",
      sortable: true,
      filter: true,
      width: 100,
      resizable: true,
      valueFormatter: (params) => {
        return params.value ? `${params.data.currency_symbol}${params.value}` : '';
      },
    },
    {
      headerName: "Total",
      field: "total",
      sortable: true,
      filter: true,
      width: 100,
      resizable: true,
      valueFormatter: (params) => {
        return params.value ? `${params.data.currency_symbol}${params.value}` : '';
      },
    },
    {
      headerName: "Payment Method",
      field: "payment_method",
      sortable: true,
      filter: true,
      width: 180,
      resizable: true,
    },
    {
      headerName: "Payment Method Title",
      field: "payment_method_title",
      sortable: true,
      filter: true,
      width: 180,
      resizable: true,
    },
    {
      headerName: "Real Auth Transactions",
      field: "real_auth_transactions",
      sortable: false,
      filter: false,
      width: 220,
      resizable: true,
      pinned: 'right',
      cellRenderer: (params) => {
        if (!params.value || !Array.isArray(params.value) || params.value.length === 0) {
          return '';
        }
        
        const ViewAuthTransactionsButton = () => {
          return (
            <button 
              className="btn btn-xs btn-outline-success"
              onClick={() => {
                setSelectedOrderForAuth(params.data);
                setShowAuthTransactionsModal(true);
              }}
            >
              View {params.value.length} {params.value.length === 1 ? 'Transaction' : 'Transactions'}
            </button>
          );
        };
        
        return <ViewAuthTransactionsButton />;
      },
    },
    {
      headerName: "Real Stripe Transactions",
      field: "real_stripe_transactions",
      sortable: false,
      filter: false,
      width: 220,
      resizable: true,
      pinned: 'right',
      cellRenderer: (params) => {
        if (!params.value || !Array.isArray(params.value) || params.value.length === 0) {
          return '';
        }
        
        const ViewStripeTransactionsButton = () => {
          return (
            <button 
              className="btn btn-xs btn-outline-success"
              onClick={() => {
                setSelectedOrderForStripe(params.data);
                setShowStripeTransactionsModal(true);
              }}
            >
              View {params.value.length} {params.value.length === 1 ? 'Transaction' : 'Transactions'}
            </button>
          );
        };
        
        return <ViewStripeTransactionsButton />;
      },
    },
    {
      headerName: "Billing Email",
      field: "billing.email",
      sortable: true,
      filter: true,
      width: 180,
      resizable: true,
    },
    {
      headerName: "Billing Phone",
      field: "billing.phone",
      sortable: true,
      filter: true,
      width: 150,
      resizable: true,
    },
    {
      headerName: "Billing Address",
      field: "billing",
      sortable: false,
      filter: false,
      width: 250,
      resizable: true,
      valueFormatter: (params) => {
        if (!params.value) return '';
        const billing = params.value;
        return `${billing.address_1 || ''} ${billing.address_2 || ''}, ${billing.city || ''}, ${billing.state || ''} ${billing.postcode || ''}, ${billing.country || ''}`.trim().replace(/, ,/g, ',').replace(/,,/g, ',');
      },
    },
    {
      headerName: "Billing City",
      field: "billing.city",
      sortable: true,
      filter: true,
      width: 120,
      resizable: true,
    },
    {
      headerName: "Billing State",
      field: "billing.state",
      sortable: true,
      filter: true,
      width: 100,
      resizable: true,
    },
    {
      headerName: "Billing Country",
      field: "billing.country",
      sortable: true,
      filter: true,
      width: 100,
      resizable: true,
    },
    {
      headerName: "Billing Postcode",
      field: "billing.postcode",
      sortable: true,
      filter: true,
      width: 120,
      resizable: true,
    },
    {
      headerName: "Transaction ID",
      field: "transaction_id",
      sortable: true,
      filter: true,
      width: 150,
      resizable: true,
    },
    {
      headerName: "Customer ID",
      field: "customer_id",
      sortable: true,
      filter: true,
      width: 120,
      resizable: true,
    },
    {
      headerName: "Customer Note",
      field: "customer_note",
      sortable: true,
      filter: true,
      width: 200,
      resizable: true,
    },
    {
      headerName: "Created Via",
      field: "created_via",
      sortable: true,
      filter: true,
      width: 120,
      resizable: true,
    },
    {
      headerName: "Date Paid",
      field: "date_paid",
      sortable: true,
      filter: 'agDateColumnFilter',  filterParams: dateFilterParams,
      width: 220,
      resizable: true,
      valueFormatter: (p) => formatDateWithTimezone(p.value, timezone),
    },
    {
      headerName: "Date Completed",
      field: "date_completed",
      sortable: true,
      filter: 'agDateColumnFilter',  filterParams: dateFilterParams,
      width: 220,
      resizable: true,
      valueFormatter: (p) => formatDateWithTimezone(p.value, timezone),
    },
  ];

  return (
    <div className="">
      <div className="">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>WordPress Orders</h4>
            </div>
          </div>

          <ul className="table-top-head">
            <li>
            {lastSyncTime && (
                <p className="text-muted">Last synced: {lastSyncTime}</p>
              )}
            </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>PDF</Tooltip>}
                >
                  <Link
                    onClick={() => {
                      // PDF export functionality would go here
                    }}
                  >
                    <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                  </Link>
                </OverlayTrigger>
              </li>
            
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Excel</Tooltip>}
                >
                  <Link
                    onClick={() => {
                      // Excel export functionality would go here
                    }}
                  >
                    <ImageWithBasePath src="assets/img/icons/xls.svg" alt="img" />
                  </Link>
                </OverlayTrigger>
              </li>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Collapse</Tooltip>}
              >
                <Link
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => dispatch(setToogleHeader(!data))}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          <div className="page-btn">
              <button 
                className="btn btn-added" 
                onClick={handleSyncWordPress}
                disabled={syncInProgress || !filters || !filters.brands || filters.brands.length === 0}
              >
                <RotateCcw className="me-2 iconsize" />
                Sync WordPress Orders
              </button>
          </div>
        </div>

        {/* Ag-Grid Table */}
        <div className="card table-list-card">
          <div
            className="ag-theme-quartz"
            style={{ height: "700px", width: "100%", overflow: "auto" }}
          >
            <AgGridReact
              columnDefs={columns}
              rowData={rowData}
              defaultColDef={{
                resizable: true,
                sortable: true,
                filter: true,
                minWidth: 80
              }}
              pagination={false}
              loading={loading}
              enableCellTextSelection={true}
              ensureDomOrder={true}
              suppressColumnVirtualisation={false}
              suppressRowVirtualisation={false}
              suppressHorizontalScroll={false}
              domLayout="normal"
            />
          </div>
        </div>
        
        {/* Modal for Line Items Details */}
        <LineItemsModal 
        show={showModal}
        onHide={() => setShowModal(false)}
        lineItems={selectedOrder ? selectedOrder.lineItemsArray : []}
      />

      <ShippingLinesModal
        show={showShippingModal}
        onHide={() => setShowShippingModal(false)}
        shippingLines={selectedShippingLines || []}
      />
      
      <RealStripeTransactionsModal
        visible={showStripeTransactionsModal}
        onClose={() => setShowStripeTransactionsModal(false)}
        order={selectedOrderForStripe}
        timezone={timezone}
      />
      
      <RealAuthTransactionsModalForWeb
        visible={showAuthTransactionsModal}
        onClose={() => setShowAuthTransactionsModal(false)}
        order={selectedOrderForAuth}
        timezone={timezone}
      />
      </div>
    </div>
  );
};

export default WordPressOrders;
